/*
 *
 * PatientIntake actions
 *
 */
import {
	CHECK_ONBOARDING,
	DOC_CREATE,
	DOC_CREATE_ERROR,
	DOC_CREATE_SUCCESS,
	DOC_SIGN,
	DOC_SIGN_ERROR,
	DOC_SIGN_SUCCESS,
	ERROR,
	FETCH_DATA,
	PATIENT_INTAKE,
	SET_PREV_PATH,
	SUCCESS,
	SUCCESS_CHECK_ONBOARDING,
} from './constants';

export function patientIntake(data, cb) {
	return {
		type: PATIENT_INTAKE,
		data,
		cb,
	};
}
export function success(response) {
	return {
		type: SUCCESS,
		data: response,
	};
}
export function error(err) {
	return {
		type: ERROR,
		data: err,
	};
}
export function fetchData(data) {
	return {
		type: FETCH_DATA,
		data,
	};
}
export function docSign() {
	return {
		type: DOC_SIGN,
	};
}
export function docSignSuccess(data) {
	return {
		type: DOC_SIGN_SUCCESS,
		data,
	};
}
// Carries a user-facing message string, NOT the raw error object — the reducer
// must never merge error internals into the intake field bag again (the
// 2026-08-07 incident). Distinct from the generic error() action so the
// component can tell a signing failure from a background save failure.
export function docSignError(message) {
	return {
		type: DOC_SIGN_ERROR,
		message,
	};
}
export function docCreate() {
	return {
		type: DOC_CREATE,
	};
}
export function docCreateSuccess(data) {
	return {
		type: DOC_CREATE_SUCCESS,
		data,
	};
}
// See docSignError. doc-create has its own terminal failure signal because a
// failed create otherwise leaves createDocSuccess false forever, stranding the
// patient on the waitingOnDoc branch (a second silent-strand path).
export function docCreateError(message) {
	return {
		type: DOC_CREATE_ERROR,
		message,
	};
}
export function checkOnboading() {
	return {
		type: CHECK_ONBOARDING,
	};
}
export function successCheckOnboading(data) {
	return {
		type: SUCCESS_CHECK_ONBOARDING,
		data,
	};
}
export function setPrevPath(data) {
	return {
		type: SET_PREV_PATH,
		data,
	};
}
